export enum InterviewStatus {
    'nostatus'= 0,
    'scheduled' = 1,
    'interviewed' = 2,
    'noshow' = 3
}

export interface CandidateDetails {
    score?: number;
    reviewsCount?: number;
    workHistory?: string;
    interviewReliability?: string;
    distanceInfo?: string;
}
